"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getSyncHash = exports.mergeSubAccounts = exports.getEstimatedFees = exports.eip1559TransactionHasFees = exports.legacyTransactionHasFees = void 0;
var ethers_1 = require("ethers");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var jsHelpers_1 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
var tokens_1 = require("@ledgerhq/cryptoassets/tokens");
/**
 * Helper to check if a legacy transaction has the right fee property
 */
var legacyTransactionHasFees = function (tx) {
    return Boolean((!tx.type || tx.type < 2) && tx.gasPrice);
};
exports.legacyTransactionHasFees = legacyTransactionHasFees;
/**
 * Helper to check if a legacy transaction has the right fee property
 */
var eip1559TransactionHasFees = function (tx) {
    return Boolean(tx.type === 2 && tx.maxFeePerGas && tx.maxPriorityFeePerGas);
};
exports.eip1559TransactionHasFees = eip1559TransactionHasFees;
/**
 * Helper to get total fee value for a tx depending on its type
 */
var getEstimatedFees = function (tx) {
    var _a, _b;
    if (tx.type !== 2) {
        return (((_a = tx.gasPrice) === null || _a === void 0 ? void 0 : _a.multipliedBy(tx.gasLimit)) ||
            new bignumber_js_1["default"](0));
    }
    return (((_b = tx.maxFeePerGas) === null || _b === void 0 ? void 0 : _b.multipliedBy(tx.gasLimit)) ||
        new bignumber_js_1["default"](0));
};
exports.getEstimatedFees = getEstimatedFees;
/**
 * List of properties of a sub account that can be updated when 2 "identical" accounts are found
 */
var updatableSubAccountProperties = [
    { name: "balance", isOps: false },
    { name: "spendableBalance", isOps: false },
    { name: "balanceHistoryCache", isOps: false },
    { name: "operations", isOps: true },
    { name: "pendingOperations", isOps: true },
];
/**
 * In charge of smartly merging sub accounts while maintaining references as much as possible
 */
var mergeSubAccounts = function (initialAccount, newSubAccounts) {
    var e_1, _a, e_2, _b, e_3, _c;
    var _d, _e;
    var oldSubAccounts = initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.subAccounts;
    if (!oldSubAccounts) {
        return newSubAccounts;
    }
    // Creating a map of already existing sub accounts by id
    var oldSubAccountsById = {};
    try {
        for (var oldSubAccounts_1 = __values(oldSubAccounts), oldSubAccounts_1_1 = oldSubAccounts_1.next(); !oldSubAccounts_1_1.done; oldSubAccounts_1_1 = oldSubAccounts_1.next()) {
            var oldSubAccount = oldSubAccounts_1_1.value;
            oldSubAccountsById[oldSubAccount.id] = oldSubAccount;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (oldSubAccounts_1_1 && !oldSubAccounts_1_1.done && (_a = oldSubAccounts_1["return"])) _a.call(oldSubAccounts_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // Looping on new sub accounts to compare them with already existing ones
    // Already existing will be updated if necessary (see `updatableSubAccountProperties`)
    // Fresh new sub accounts will be added/pushed after already existing
    var newSubAccountsToAdd = [];
    try {
        for (var newSubAccounts_1 = __values(newSubAccounts), newSubAccounts_1_1 = newSubAccounts_1.next(); !newSubAccounts_1_1.done; newSubAccounts_1_1 = newSubAccounts_1.next()) {
            var newSubAccount = newSubAccounts_1_1.value;
            var duplicatedAccount = oldSubAccountsById[newSubAccount.id];
            // If this sub account was not already in the initialAccount
            if (!duplicatedAccount) {
                // We'll add it later
                newSubAccountsToAdd.push(newSubAccount);
                continue;
            }
            var updates = {};
            try {
                for (var updatableSubAccountProperties_1 = (e_3 = void 0, __values(updatableSubAccountProperties)), updatableSubAccountProperties_1_1 = updatableSubAccountProperties_1.next(); !updatableSubAccountProperties_1_1.done; updatableSubAccountProperties_1_1 = updatableSubAccountProperties_1.next()) {
                    var _f = updatableSubAccountProperties_1_1.value, name_1 = _f.name, isOps = _f.isOps;
                    if (!isOps) {
                        if (newSubAccount[name_1] !== duplicatedAccount[name_1]) {
                            updates[name_1] = newSubAccount[name_1];
                        }
                    }
                    else {
                        updates[name_1] = (0, jsHelpers_1.mergeOps)(duplicatedAccount[name_1], newSubAccount[name_1]);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (updatableSubAccountProperties_1_1 && !updatableSubAccountProperties_1_1.done && (_c = updatableSubAccountProperties_1["return"])) _c.call(updatableSubAccountProperties_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            // Updating the operationsCount in case the mergeOps changed it
            updates.operationsCount =
                ((_d = updates.operations) === null || _d === void 0 ? void 0 : _d.length) || ((_e = duplicatedAccount === null || duplicatedAccount === void 0 ? void 0 : duplicatedAccount.operations) === null || _e === void 0 ? void 0 : _e.length) || 0;
            // Modifying the Map with the updated sub account with a new ref
            oldSubAccountsById[newSubAccount.id] = __assign(__assign({}, duplicatedAccount), updates);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (newSubAccounts_1_1 && !newSubAccounts_1_1.done && (_b = newSubAccounts_1["return"])) _b.call(newSubAccounts_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    var updatedSubAccounts = Object.values(oldSubAccountsById);
    return __spreadArray(__spreadArray([], __read(updatedSubAccounts), false), __read(newSubAccountsToAdd), false);
};
exports.mergeSubAccounts = mergeSubAccounts;
/**
 * Method creating a hash that will help triggering or not a full synchronization on an account.
 * As of now, it's checking if a token has been added, removed of changed regarding important properties
 */
var getSyncHash = function (currency) {
    var tokens = (0, tokens_1.listTokensForCryptoCurrency)(currency);
    var basicTokensListString = tokens
        .map(function (token) {
        return token.id +
            token.contractAddress +
            token.name +
            token.ticker +
            token.delisted;
    })
        .join("");
    return ethers_1.ethers.utils.sha256(Buffer.from(basicTokensListString));
};
exports.getSyncHash = getSyncHash;
//# sourceMappingURL=logic.js.map